export function shouldIgnoreProp(...blacklist: string[]): (prop: string) => boolean {
    return (prop: string) => !blacklist.includes(prop);
}
